import { Component, OnInit } from '@angular/core';
import { CarrierAccountService } from 'app/services/carrier-account.service';
import { AuthWebService } from 'app/services/authweb.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { CorspdcService } from 'app/services/corspdc.service';
import { PopupService } from 'app/services/shared/popup.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { AssignRolePopupComponent } from './popups/assign-role-popup.component';
import { CarrierService } from 'app/services/carrier.service';
import { FormsModule } from '@angular/forms';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';
import { Console } from 'console';

@Component({
  selector: 'app-consultant',
  templateUrl: './consultant.component.html',
  styleUrls: ['./consultant.component.css']
})
export class ConsultantComponent implements OnInit {

  carrierData: any = null;

  carrierID: number;

  isLoading: boolean = false;
  isEmpty: boolean = false;
  consultants: any = [];
  user: any = {};
  page = 1
  user_email: string = "";
  user_number: string = "";
  user_name: any;
  username: string = "";
  status: any = "0";
  role: any = "0";
  count: number = 0;
  utility: any;
  message = "Submitting your request, please wait...";
  person_id: string;
  carrier_name: string;
  person: any;
  proceedDisabled = true;
  roleServedInd: number;
  edit: boolean;
  title: string;
  roles: any = [
    { role: 1, desc: "Lead User" },
    { role: 2, desc: "Editor User" },
    { role: 6, desc: "Read User" },
    { role: 11, desc: "Owner" },
    { role: 12, desc: "Consultant" },
    { role: 21, desc: "Main Contact" }
  ];


  constructor(private carrierService: CarrierService, 
    private carrierAccountService: CarrierAccountService, private authWebService: AuthWebService, private router: Router,
    private toaster: ToastrService, private datepipe: DatePipe, private activeRoute: ActivatedRoute, private crspdService: CorspdcService, private showModal: PopupService,private confirmDialogService: ConfirmDialogService) {
    this.user = (this.authWebService.userData) ? this.authWebService.userData.User : null;
  }


  ngOnInit() {
    this.activeRoute.params.subscribe(params => {
      this.carrierID = params['id'];
      this.carrierService.getCarrierById(this.carrierID).subscribe(result => {
        this.carrierData = result;
        this.carrier_name = this.carrierData.name
      });
    });

    this.getConsultantsList(this.carrierID);
  }

  linkUser() {
    if (this.carrierData != null && (this.user_email.length > 0 || this.username.length > 0)) {
      this.isLoading = true;
      this.carrierAccountService.getUserToLink(this.user_email.length > 0 ? this.user_email.toLowerCase() : null, this.username.length > 0 ? this.username.toLowerCase() : null, this.carrierID).subscribe((result:any) => {
        this.isLoading = false;
        if (result == null) {
          this.toaster.warning('The user does not exist. Please ensure you have captured the correct email/username.');
        }
        else if(result.person_id == -1){
          this.toaster.warning(result.first_name + " " + result.last_name + ' is already linked to ' + this.carrierData.name + ' account and cannot be linked again.');
        }
        else {
         // document.getElementById('secretButton').click();
          //this.title = "Link user";
          //this.person = result;
          //this.edit= false;
          //  this.dialogService.addDialog(AssignRolePopupComponent, {
          //    title: "Link user",
          //    message: result.first_name + ' ' + result.last_name + ' retrieved succesfully.',
          //    comment: `Please select role you want to give user before proceeding.`,
          //    confirmButtonText: "Proceed",
          //    cancelButtonText: "Cancel",
          //    person: result,
          //    carrierID: this.carrierID,
          //    carrierData: this.carrierData,
          //    edit: false
          //  }).subscribe((isConfirmed) => {
          //    if (isConfirmed) {
          //      this.getConsultantsList(this.carrierID);
          //    } else {
          //      return;
          //    }
          //  });

           this.confirmDialogService.confirmThis("You have selected '" + this.roles.find(r => r.role == this.roleServedInd).desc + " Role' for user " + this.person.first_name + " " + this.person.last_name +". Do you want to send user a One time Password to link them to " + this.carrierData.name + " account?", () => {  
            if (this.edit) {
              this.carrierAccountService.changeRoleForCarrierPerson(this.carrierID, this.person.person_id, this.roleServedInd, this.authWebService.userData.User.UserName).subscribe(result => {
                this.toaster.success('The role for ' + this.person.first_name + " " + this.person.last_name + ' has been changed succesfully.');
                this.getConsultantsList(this.carrierID);
              });
            }
            else {
              this.carrierAccountService.linkCarrrierPerson(this.carrierID, this.person.person_id, this.roleServedInd, this.authWebService.userData.User.UserName).subscribe(result => {
                if (result == "Person already linked.") {
                  this.toaster.warning(this.person.first_name + " " + this.person.last_name + ' is already linked to ' + this.carrierData.name + ' account and cannot be linked again.');
                }
                else if (result == "success") {
                  this.toaster.success(this.person.first_name + " " + this.person.last_name + ' has been sent an OTP to link your Account: ' + this.carrierData.name +' . Please check your email.');
                } else {
                }
    
              });
            }
    
          
          }, () =>  {  
          }) 
        }
      }, error => {
        this.isLoading = false;
        this.toaster.error("Unexpected error occured. Please contact the system administrator if the problem persists.", "");
      });
    }
  }

  cancel() {
    //Takes back to the previous page
    this.router.navigate(['carrier/accounts/']);
  }

  onReset() {
    //Reset the filters
    this.role = "0";
    this.user_name = null;
    this.status = "0";
    this.getConsultantsList(this.carrierID);
  }

  onSearch() {
    //Search based on the filters   
    this.getConsultantsList(this.carrierID, this.user_name, this.status, this.role);
  }

  resendOTP(carrier_person_id) {
    this.isLoading = true;
    this.carrierAccountService.ResendAccountLinkingOTP(this.authWebService.userData.User.UserName, carrier_person_id).subscribe(result => {
      this.isLoading = false;
      this.toaster.success('OTP sent succesfully.');
    });
  }


  //Update the role and the status
  updateConsultant(consultant: any) {

    this.message = "Updating carrier account's person details,please wait...";
    this.isLoading = true;
    this.carrierService.putConsultant(consultant).subscribe(result => {

      this.isLoading = false;

      //this.toaster.success("Carrier Account's details updated successfully.", "Carrier Account's details", { timeOut: 1000 });
      this.getConsultantsList(this.carrierID);
    }, error => {
      this.isLoading = false;
      this.toaster.error("Carrier Account's details could not be updated.Please contact the system administrator if the problem persists.", "Carrier Account's details")
    });

  }


  getConsultantsList(id: number, username?: string, user_status?: string, role?: number) {
    this.isLoading = true;

    this.carrierService.getConsultantByAccount(id, username, user_status, role).subscribe((result:any) => {
      this.consultants = result;
      this.count = result.Count;
      this.isEmpty = (this.count == 0) ? true : false;
      console.dir(this.consultants);
      this.isLoading = false;

    }, error => {
      this.isLoading = false;
      this.isEmpty = true;
      //console.log('Error occured: ' + error);

    })
  }

  selectOptionList(selectedvalue, cons) {
    //console.log(cons);
    switch (selectedvalue) {
      case "0":
        //Mark as Inactive
      
        cons.status = "Inactive";
        this.updateConsultant(cons);
      

        break;
      case "1":
        //Change role
        this.ChangeUserRole(cons);
        break;

      case "2":
        //Resend OTP
        this.resendOTP(cons.carrier_person_id);

        break;

      default:
        break;

    }
  }

  ChangeUserRole(person) {
    //document.getElementById('secretButton').click();
    //this.title = "Change User Role";
    //this.person = person;
    //this.edit = true;
    //  this.dialogService.addDialog(AssignRolePopupComponent, {
    //    title: "Change User Role",
    //    message: "Change user role for " + person.first_name + ' ' + person.last_name + '.',
    //    comment: `Please select role you want to give user before proceeding.`,
    //    confirmButtonText: "Proceed",
    //    cancelButtonText: "Cancel",
    //    person: person,
    //    carrierID: this.carrierID,
    //    carrierData: this.carrierData,
    //    edit: true
    //  }).subscribe((isConfirmed) => {
    //    if (isConfirmed) {
    //      this.getConsultantsList(this.carrierID);
    //    } else {
    //      return;
    //    }
    //  });
     this.confirmDialogService.confirmThis("You have selected '" + this.roles.find(r => r.role == this.roleServedInd).desc + " Role' for user " + this.person.first_name + " " + this.person.last_name +". Do you want to send user a One time Password to link them to " + this.carrierData.name + " account?", () => {  
      if (this.edit) {
        this.carrierAccountService.changeRoleForCarrierPerson(this.carrierID, this.person.person_id, this.roleServedInd, this.authWebService.userData.User.UserName).subscribe(result => {
          this.toaster.success('The role for ' + this.person.first_name + " " + this.person.last_name + ' has been changed succesfully.');
          this.getConsultantsList(this.carrierID);
        });
      }
      else {
        this.carrierAccountService.linkCarrrierPerson(this.carrierID, this.person.person_id, this.roleServedInd, this.authWebService.userData.User.UserName).subscribe(result => {
          if (result == "Person already linked.") {
            this.toaster.warning(this.person.first_name + " " + this.person.last_name + ' is already linked to ' + this.carrierData.name + ' account and cannot be linked again.');
          }
          else if (result == "success") {
            this.toaster.success(this.person.first_name + " " + this.person.last_name + ' has been sent an OTP to link your Account: ' + this.carrierData.name +' . Please check your email.');
          } else {
          }

        });
      }

    
    }, () =>  {  
    })
  }

  cancelRoleChange() {
    //this.result = false;
    //this.close();
  }
  roleChange(roleServed) {
    this.proceedDisabled = false;
    this.roleServedInd = roleServed.value;
  }


  confirm(thisModal) {
    thisModal.style.display = "none";
      this.confirmDialogService.confirmThis("You have selected '" + this.roles.find(r => r.role == this.roleServedInd).desc + " Role' for user " + this.person.first_name + " " + this.person.last_name +". Do you want to send user a One time Password to link them to " + this.carrierData.name + " account?", () => {  
        if (this.edit) {
          this.carrierAccountService.changeRoleForCarrierPerson(this.carrierID, this.person.person_id, this.roleServedInd, this.authWebService.userData.User.UserName).subscribe(result => {
            this.toaster.success('The role for ' + this.person.first_name + " " + this.person.last_name + ' has been changed succesfully.');
            this.getConsultantsList(this.carrierID);
            return true;
          });
        }
        else {
          this.carrierAccountService.linkCarrrierPerson(this.carrierID, this.person.person_id, this.roleServedInd, this.authWebService.userData.User.UserName).subscribe(result => {
            if (result == "Person already linked.") {
              this.toaster.warning(this.person.first_name + " " + this.person.last_name + ' is already linked to ' + this.carrierData.name + ' account and cannot be linked again.');
              return false;
            }
            else if (result == "success") {
              this.toaster.success(this.person.first_name + " " + this.person.last_name + ' has been sent an OTP to link your Account: ' + this.carrierData.name +' . Please check your email.');
              this.getConsultantsList(this.carrierID);
              return true;
            } else {
              return false;
            }

          });
        }

      
      }, () =>  {  
        //this.result = false;
      }) 
  }


}
